// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608182354/js/" + chunkId + "." + {"44":"54be9dac","225":"ce064c0a","481":"cd55db1f","486":"de79bfff","770":"6ccc9c8f"}[chunkId] + ".0.5143627557116557.chunk.js";
};